import { render, staticRenderFns } from "./role.vue?vue&type=template&id=302b15d6"
import script from "./role.vue?vue&type=script&lang=ts"
export * from "./role.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports